import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodalfoodcourtComponent } from 'src/app/modal/remove-modal-food-court/remove-modal-food-court.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-list-food-court',
  templateUrl: './list-food-court.component.html',
  styleUrls: ['./list-food-court.component.scss']
})
export class ListFoodCourtComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainFoodCourtList: any[] = [];
  newmainFoodCourtList: any[] = [];
  foodcourtDeepCopy: any;
  newMainFoodCourts: any;
  foodcourtTempNew: any;
  masterSelectedFoodCourt: boolean;
  checkedFoodCourtList: any;
  checkedOnlyFoodCourtList: any;
  onlyFoodCourtIds = [];
  selectedFoodCourtName: any;
  mainFoodCourtTypes = [];
  multiSelectGroup: any;
  searchFoodCourtList = [];
  closedType: any;
  singleFoodCourtDataDelete = [];
  foodCourtEdit: any;
  foodCourtRemove: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {
    this.foodCourtEdit = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Edit');
    this.foodCourtRemove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Remove');
    
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    this.getTheFoodCourtList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroup == 'All') {
        this.newmainFoodCourtList = this.mainFoodCourtList;
      } else {
        if (this.searchFoodCourtList.length > 0) {
          this.newmainFoodCourtList = this.searchFoodCourtList;
        } else {
          this.newmainFoodCourtList = this.mainFoodCourtList;
        }
      }
      this.totalRows = this.newmainFoodCourtList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    this.newmainFoodCourtList = this.mainFoodCourtList.filter((item: { foodCourtName: any }) => {
      if (!item || !item.foodCourtName) return false;
      return item.foodCourtName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainFoodCourtList?.length;
  }


  handelFoodCourtList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainFoodCourtList.length; i++) {
      this.mainFoodCourtList[i].isSelected = this.masterSelectedFoodCourt;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedFoodCourt);
    if (this.masterSelectedFoodCourt === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedFoodCourt = this.mainFoodCourtList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedFoodCourt);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedFoodCourtList = [];
    this.checkedOnlyFoodCourtList = [];
    this.onlyFoodCourtIds = [];

    for (var i = 0; i < this.mainFoodCourtList?.length; i++) {

      if (this.mainFoodCourtList[i].isSelected) {
        this.checkedFoodCourtList.push(this.mainFoodCourtList[i]);
        this.checkedOnlyFoodCourtList.push(this.mainFoodCourtList[i]);
        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlyFoodCourtList?.length; j++) {
      this.onlyFoodCourtIds.push(this.checkedOnlyFoodCourtList[j].foodCourtId);
    }

    console.log(this.onlyFoodCourtIds);
    this.checkedFoodCourtList = JSON.stringify(this.checkedFoodCourtList);

  }

  getTheFoodCourtList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.foodcourtService.mainFoodCourtList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainFoodCourtList = res?.list;
        // this.newmainSurveyList = res?.list;
        this.newmainFoodCourtList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        this.newMainFoodCourts = res;
        this.foodcourtDeepCopy = JSON.parse(JSON.stringify(res));
        this.foodcourtTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainFoodCourtList = [];
        this.newmainFoodCourtList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainFoodCourtList?.length; i++) {
      this.mainFoodCourtList[i].isSelected = false;
    }

    console.log(this.mainFoodCourtList);
    this.getCheckedItemList();
  }

  openModalRemoveFoodCourt(foodCourtVendorId: any): void {

    this.singleFoodCourtDataDelete = [];

    /*this.singleVendorDataDelete.push({
      "foodCourtVendorIds": foodCourtVendorId, //this.onlyVendorIds
      // "deletedBy": localStorage.getItem('claAdminId')
    });*/

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalfoodcourtComponent, modalOptions);
    // modalRef.componentInstance.foodCourtVendorId = this.singleVendorDataDelete[0];
    modalRef.componentInstance.foodCourtId = this.onlyFoodCourtIds;
    modalRef.componentInstance.fromDetailsPage = 'no';
  }

  goToVendorListPage(id: string, name: string) {
    localStorage.setItem('food_court_id', id);
    localStorage.setItem('food_court_name', name);
    this.router.navigate(['/list-food-vendor/' + id]);
  }

  goToEditPage(id: string) {
    console.log(id);
    this.router.navigate(['/update-food-court/' + id]);
  }

  addNewFoodCourt() {
    this.router.navigate(['/create-food-court/']);
  }

}
